import React, { useState } from 'react'
import RNPickerSelect from 'react-native-picker-select'
import Show from '@components/Show'
import { colors } from '@lib/colors'
import { Platform, StyleSheet, Text, View } from 'react-native'

interface PickerItem {
  label: string,
  value?: unknown
}
interface PickerProps {
  label?: string,
  value?: Maybe<string>
  items: PickerItem[]
  style?: any
  borderStyle?: any
  labelStyle?: any
  placeholder?: string
  onValueChange: (value?: string | number) => void
}

export default function (props: PickerProps) {
  const {
    value,
    label,
    labelStyle,
    borderStyle,
    style,
    items,
    placeholder,
    onValueChange,
  } = props

  const [focused, setFocused] = useState<boolean>(false)

  const getPlaceholder = () => {
    return placeholder ? { label: placeholder, value: null } : {}
  }

  const getLabelStyles = () => {
    if (labelStyle) return labelStyle
    if (focused) return { ...styles.labelBase, ...styles.labelActive }
    return { ...styles.labelBase, ...styles.labelInactive }
  }

  const getBorderStyles = () => {
    if (borderStyle) return borderStyle
    if (focused) return { ...styles.borderBase, ...styles.borderActive }
    if (value !== null) return { ...styles.borderBase, ...styles.borderFilled }
    return { ...styles.borderBase, ...styles.borderEmpty }
  }

  const getPickerStyles = () => {
    if (style) return style
    if (value !== null) return filledPickerStyles
    return emptyPickerStyles
  }

  const focusOnOpenForIOS = () => {
    // This is because onClose is not supported for Android on RNPickerSelect
    if (Platform.OS === 'ios') setFocused(true)
  }

  const blurOnCloseForIOS = () => {
    setFocused(false)
  }

  return (
    <View style={ getBorderStyles() }>
        <RNPickerSelect
          useNativeAndroidPickerStyle={false}
          onValueChange={ onValueChange }
          onOpen={ focusOnOpenForIOS }
          onClose={ blurOnCloseForIOS }
          placeholder={ getPlaceholder() }
          value={ value }
          style={ getPickerStyles() }
          items={ items as any }
        />
      <Show when={ value !== null }>
        <Text style={ getLabelStyles() }>{ label }</Text>
      </Show>
    </View>
  )
}

const emptyPickerStyles = StyleSheet.create({
  inputIOS: {
    backgroundColor: colors.gray[50],
    borderRadius: 4,
    padding: 12,
    paddingRight: 30,
  },
  inputAndroid: {
    backgroundColor: colors.gray[50],
    borderRadius: 4,
    padding: 12,
    paddingRight: 30,
  },
})

const filledPickerStyles = StyleSheet.create({
  inputIOS: {
    backgroundColor: colors.white,
    borderRadius: 4,
    padding: 12,
    paddingRight: 30,
  },
  inputAndroid: {
    backgroundColor: colors.white,
    borderRadius: 4,
    color: colors.black,
    padding: 12,
    paddingRight: 30,
  },
})

const styles = StyleSheet.create({
  // Label
  labelBase: {
    position: 'absolute',
    left: 12,
    top: -6,
    backgroundColor: colors.white,
    paddingLeft: 2,
    paddingRight: 2,
    fontSize: 12,
    fontWeight: '600',
  },
  labelInactive: {
    color: colors.gray[400],
  },
  labelActive: {
    color: colors.blue[400],
  },

  // Border
  borderBase: {
    position: 'relative',
    backgroundColor: colors.gray[50],
    borderRadius: 6,
    marginTop: 15,
    padding: 2,
  },
  borderActive: {
    backgroundColor: colors.blue[200],
  },
  borderEmpty: {
    backgroundColor: colors.gray[50],
  },
  borderFilled: {
    backgroundColor: colors.gray[100],
  },
})
